module.exports = __webpack_public_path__ + "static/media/axilor-logo.9b5f8df9.png";